module.exports = __webpack_public_path__ + "static/media/logoutIcon.37c8fa65.svg";